// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2023-2024 (original work) Open Assessment Technologies SA;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.studentSessions.sessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/studentSessions')
    },
    {
        path: [config.routes.studentSessions.reviewSession],
        guard: getPermissionsGuard([
            { resource: 'portal.my-session', scopes: ['review'] },
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.support', scopes: ['view'] },
            { resource: 'portal.review-session', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/reviewSession')
    },
    {
        path: [config.routes.studentSessions.finishedSessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/finishedSessions')
    }
];
